import deburr from 'lodash.deburr';
import escapeStringRegexp from 'escape-string-regexp';
import builtInReplacements from './replacements';
const decamelize = string => string
// Separate capitalized words.
.replace(/([A-Z]{2,})([a-z\d]+)/g, '$1 $2').replace(/([a-z\d]+)([A-Z]{2,})/g, '$1 $2').replace(/([a-z\d])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1 $2');
function doCustomReplacements(input, replacements) {
  let string = input;
  replacements.forEach(_ref => {
    let [key, value] = _ref;
    string = string.replace(new RegExp(escapeStringRegexp(key), 'g'), value);
  });
  return string;
}
const removeMootSeparators = (string, separator) => string.replace(new RegExp(`${separator}{2,}`, 'g'), separator).replace(new RegExp(`^${separator}|${separator}$`, 'g'), '');
export default function slugify(input, options) {
  let string = input;
  if (typeof string !== 'string') {
    throw new TypeError(`Expected a string, got \`${typeof string}\``);
  }
  const separator = escapeStringRegexp(options?.separator || '-');
  const replacements = [['&', ' and '], ...(options?.replacements || []), ...builtInReplacements];
  string = doCustomReplacements(string, replacements);
  string = deburr(string);
  string = string.normalize('NFKD');
  if (options?.decamelize ?? true) {
    string = decamelize(string);
  }
  let patternSlug = /[^a-zA-Z\d]+/g;
  if (options?.lowercase ?? true) {
    string = string.toLowerCase();
    patternSlug = /[^a-z\d]+/g;
  }
  string = string.replace(patternSlug, separator);
  string = string.replace(/\\/g, '');
  string = removeMootSeparators(string, separator);
  return string;
}